import { DeploymentTargetBcx } from '@bluecodecom/types/common';

const DEPLOYMENT_TARGET_ENV = process.env[
  'NX_PUBLIC_DEPLOYMENT_TARGET'
] as DeploymentTargetBcx;

class ConfigService {
  private static instance: ConfigService;

  private _deploymentTarget: DeploymentTargetBcx =
    DEPLOYMENT_TARGET_ENV || 'bcx-dev';

  public get deploymentTarget() {
    return this._deploymentTarget;
  }

  public get isNotProd() {
    return !['bci-prod', 'ngc-prod'].includes(this.deploymentTarget);
  }

  public get domain() {
    switch (this._deploymentTarget) {
      case 'bcx-dev':
        return 'spt-payments.mobi';
      case 'bcx-int':
        return 'spt-payments.biz';
      case 'bcx-prod':
        return 'spt-payments.com';
    }

    throw new Error('Unknown env ' + this._deploymentTarget);
  }

  public static getInstance() {
    if (!ConfigService.instance) {
      ConfigService.instance = new ConfigService();
    }

    return ConfigService.instance;
  }
}

const configService = ConfigService.getInstance();

export default configService;
